<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />
    <v-card>
      <v-card-title>
        Promoções por cliente
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  label="Clientes"
                  v-model="search"
                  prepend-icon="mdi-office-building"
                  @input="searchBar()"
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-card-text>
        <v-list-group v-for="(client, id) in searchClients" :key="id" no-action>
          <template v-slot:activator>
            <v-list-item-title>{{ client.name }}</v-list-item-title>
          </template>

          <v-list-item
            v-for="(category, id) in category"
            :key="id"
            @click="getPromotions(client, category)"
          >
            {{ category.name }}
          </v-list-item>
        </v-list-group>
      </v-card-text>
    </v-card>

    <template>
      <v-dialog
        v-model="modalEditPromotion"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <div>
              Promoções {{ selectedCategory.name }} <br />em
              {{ selectedClient.name }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items="promotions"
              :headers="promotionsHeader"
              :single-select="false"
              :items-per-page="10"
              v-model="promotions"
              item-key="id"
              no-data-text="Nenhuma promoção encontrada"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>
                      <v-checkbox
                        v-model="item.active"
                        :value="item.active"
                        @click="activeOrDiseblePromotion(item)"
                        style="margin:0px;padding:0px"
                        hide-details
                      />
                    </td>
                    <td class="text-center">{{ item.name }}</td>
                    <td class="text-center">{{ item.type }}</td>
                    <td
                      v-if="item.type == 'package'"
                      class="text-center "
                    >
                      {{
                        item.package_value
                          | formatPrice
                      }}
                    </td>
                    <td class="text-center" v-else>
                      {{
                        item.activation_value 
                          | formatPrice
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="cancel()"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1 white--text" text @click="save()"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>

import { blockScreenUi } from './../../helpers/BlockScreenUi';
import ClientController from '../../controllers/ClientController';
import VehicleCategoryController from '../../controllers/VehicleCategoryController.js';
import PromotionController from '../../controllers/PromotionController';
import PromotionClientController from '../../controllers/PromotionClientController'
import NumberHelper from './../../helpers/NumberHelper';

export default {
  created() {
    this.clientController = new ClientController(this.$resource);
    this.vehicleCategoryController = new VehicleCategoryController(
      this.$resource
    );
    this.getClients();
    this.getCategory();
  },

  data() {
    return {
      blockScreen: false,
      blockScreenData: blockScreenUi.blockScreenData,
      promotionController: new PromotionController(this.$resource),
      promotionClientController: new PromotionClientController(this.$resource),
      modalEditPromotion: false,
      clients: [],
      search: '',
      searchClients: [],
      promotions: [],
      category: [],
      selectedCategory: {},
      selectedClient: {},
      upgradePromotion: [],
      promotionsHeader: [
        { text: 'Seleção', aling: 'center', value: 'checkbox'},
        { text: 'Nome', align: 'center', value: 'name' },
        { text: 'Tipo', align: 'center', value: 'type' },
        { text: 'Ativação', align: 'center', value: 'promotion_vehicle_model' },
      ],
    };
  },
  filters: {
    formatPrice(price) {
      return `R$ ${NumberHelper.formatPrice(price)} `;
    },
  },
  methods: {
    searchBar() {
      this.searchClients = [];
      if (this.search.length > 0) {
        this.clients.forEach(clients => {
          let name = clients.name.toLowerCase();
          let search = this.search.toLowerCase();
          if (name.search(search) >= 0) {
            this.searchClients.push(clients);
          }
        });
      } else {
        this.searchClients = this.clients;
      }
    },
    getClients() {
      this.blockScreen = true

      try {
        this.clientController.getAllClientsTypeCondominio().then(clients => {
        this.clients = clients;
        this.searchClients = this.clients;
      });
      } catch (error) {
        console.log(error)
      } finally {
        this.blockScreen = false
      }
    },
    getCategory() {
      this.vehicleCategoryController
        .getAll()
        .then(res => (this.category = res));
    },

    activeOrDiseblePromotion (item) {
      let promotion = {
        promotionId: item.id,
        clientId: this.selectedClient.id,
        status: item.active,
        activation_value: item.activation_value,
        package_value: item.package_value,
        vehicleModelCategory: item.vehicles_model_category,
        type: item.type
      }
      this.upgradePromotion.push(promotion)
    },

    save () {
      this.blockScreen = true
      this.promotionClientController
        .updatePromotionClient(this.upgradePromotion)
        .then(res => this.$awn.success(res.body.message))
        .catch(error => this.$awn.alert(error.body))
        .finally(
          this.modalEditPromotion = false,
          this.upgradePromotion = [],
          this.blockScreen = false
        )
    },

    cancel() {
      this.upgradePromotion = [];
      this.promotions = [];
      this.modalEditPromotion = false;
    },

    async getPromotions(client, category) {
      this.blockScreen = true
      this.selectedClient = client;
      this.selectedCategory = category;
      this.promotions = [];
      await this.promotionController
        .getPromotionByClientAndVehicleModel(client.id, category.id)
        .then(res => (this.promotions = res))
        .catch(e => console.log(e))
        .finally(
          this.modalEditPromotion = true,
          this.blockScreen = false
        )
    },
  },
};
</script>

<style>
.promotions {
  font-size: 17px;
}
</style>
